import { render, staticRenderFns } from "./WebsiteBasicsControl.vue?vue&type=template&id=a49a6068&"
import script from "./WebsiteBasicsControl.vue?vue&type=script&lang=js&"
export * from "./WebsiteBasicsControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports